import { UseMutationResult, useMutation, UseQueryResult, useQuery, useQueryClient } from '@tanstack/react-query'
import { CancelHandshakeInput, CancelHandshakeResponse, deleteAgentImmediatelyInput, deleteAgentImmediatelyResponse, GetAgentListInput, GetAgentListResponse, GetContactByIdResponse } from 'services/interface'

import { cancelHandshake, deleteAgentImmediately, getAgentById, getAgentsList } from 'services/agentsApi'

export const useGetAentsList = (input: GetAgentListInput): UseQueryResult<GetAgentListResponse, Error> => {
  return useQuery<GetAgentListResponse, Error>({
    queryKey: ['agentsList', input],
    queryFn: () => getAgentsList(input),
    staleTime: 1000 * 60 * 60 * 24,  
  })
}

export const useGetAgentById = (
  agentId: string
): UseQueryResult<GetContactByIdResponse, Error> => {
  return useQuery<GetContactByIdResponse, Error>({
    queryKey: ['agents', agentId],
    queryFn: () => getAgentById(agentId),
    // staleTime: 1000 * 60 * 60 * 1,
  })
}

export const useCancelHandshake = (): UseMutationResult<
  CancelHandshakeResponse,
  Error,
  CancelHandshakeInput,
  unknown
> => {
  const queryClient = useQueryClient()
  return useMutation<CancelHandshakeResponse, Error, CancelHandshakeInput, unknown>({
    mutationFn: (input: CancelHandshakeInput): Promise<CancelHandshakeResponse> => cancelHandshake(input),
    onSuccess: () => {
      // Handle success
      queryClient.invalidateQueries({ queryKey: ['agentsList'] })
    },
  })
}

// export const useDeleteAgentImmediately= (): UseMutationResult<
//   deleteAgentImmediatelyResponse,
//   Error,
//   deleteAgentImmediatelyInput,
//   unknown
// > => {
//   return useMutation<
//     deleteAgentImmediatelyResponse,
//     Error,
//     deleteAgentImmediatelyInput,
//     unknown
//   >(
//     (input: deleteAgentImmediatelyInput): Promise<deleteAgentImmediatelyResponse> =>
//     deleteAgentImmediately(input),
//     {
//       onSuccess: () => {
        
//       },
//     }
//   )
// }

export const useDeleteAgentImmediately = (): UseMutationResult<
  deleteAgentImmediatelyResponse,
  Error,
  deleteAgentImmediatelyInput,
  unknown
> => {
  const queryClient = useQueryClient()
  return useMutation<deleteAgentImmediatelyResponse, Error, deleteAgentImmediatelyInput, unknown>({
    mutationFn: (input: deleteAgentImmediatelyInput): Promise<deleteAgentImmediatelyResponse> => deleteAgentImmediately(input),
    onSuccess: () => {
      // Handle success
      queryClient.invalidateQueries({ queryKey: ['agentsList'] })
    },
  })
}